<div class="row">

  <!-- Icon -->
  <ng-container [ngSwitch]="element.status">
    <div *ngSwitchCase="TimelineElementStatus.NONE" class="icon"></div>
    <div *ngSwitchCase="TimelineElementStatus.CHECKED" class="icon success">
      <mat-icon>done</mat-icon>
    </div>
    <div *ngSwitchCase="TimelineElementStatus.ERROR" class="icon error">
      <mat-icon>clear</mat-icon>
    </div>
  </ng-container>

  <!-- Title -->
  <span class="title">{{element.title}}</span>

  <!-- Timestamp -->
  <span class="date">{{element.timestamp | date:'medium'}}</span>

</div>

<!-- Description -->
<div class="description">{{element.description}}</div>

<!-- Set ✓ or ✕ -->
<div *ngIf="canEdit" class="buttons" [ngStyle]="{opacity: element.status == TimelineElementStatus.NONE ? 1 : 0}">
  <button mat-flat-button class="button success" (click)="onUpdate.emit({groupId: group.id, elementId: element.id, isExecuted: true})" [disabled]="element.status != TimelineElementStatus.NONE">✓</button>
  <button mat-flat-button class="button error" (click)="onUpdate.emit({groupId: group.id, elementId: element.id, isExecuted: false})" [disabled]="element.status != TimelineElementStatus.NONE">✕</button>
</div>
